export default "__VITE_ASSET__EX0o8Z3g__"